<template>
  <div>
    <my-head></my-head>
    <div class="newslist minH margin-auto">
      <div class="crumbs">
        首页 >
        <span style="color: #1d2129">信息互联</span>
      </div>

      <div class="title">信息互联</div>

      <div class="title1">
        <a :class="{active: active == 1}" @click="handleSelect(1)">
          <img src="../assets/xxhl1.png" alt="上海技术交易所">
        </a>
        <a :class="{active: active == 2}" @click="handleSelect(2)">
          <img src="../assets/xxhl2.png" alt="华能科创专区">
        </a>
        <a :class="{active: active == 3}" @click="handleSelect(3)">
          <img src="../assets/xxhl3.png" alt="临沂交易中心">
        </a>
      </div>

      <div v-show="active != 2">
        <!-- 搜索框 -->
        <div class="flex-left-center sou_suo">
          <input type="text" v-model="ssInput" placeholder="请输入项目名称">
          <img src="../assets/search.png" alt="" @click="souSuo">
          <div class="ss_but flex-center" @click="souSuo">搜索</div>
        </div>

        <div class="col flex-between-left" v-for="(item, index) in listCards" :key="index" @click="toNewsD(item.id)">
          <div :style="`width: ${item.imageUrl ? '82%' : '100%'}`">
            <div class="col_title line">
              {{ item.title }}
            </div>

            <div class="col_time" v-show="item.createTime">
              {{ item.createTime | dateYMD }}
            </div>

            <div class="list-fields" v-if="item.summary.fields.length">
              <div class="field" v-for="(field, fIdx) in item.summary.fields" :key="fIdx">
                <span class="k">{{ field.label }}</span>
                <span class="v">{{ field.value }}</span>
              </div>
            </div>

            <div class="col_intro line-two" v-if="item.summary.intro">
              {{ item.summary.intro }}
            </div>
            <div class="col_content line-two" v-else-if="!item.summary.fields.length" v-html="item.content"></div>
          </div>
          <img :src="item.imageUrl" alt="" />
        </div>

        <!-- 分页 -->
        <div class="flex-center fen_ye">
          <el-pagination background :current-page.sync="nespage.page" :page-size="nespage.size"
            layout="prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
      <div v-show="active == 2">
        <div class="capital_title">平台介绍 <span>Platform Introduction</span></div>

        <div class="capital_content">
          华能集团科技创新成果运营平台是中国华能集团倾力打造的能源领域数字化科技服务平台。聚焦集团内部核心科技成果与专利资源，重点布局清洁能源、智慧发电、储能技术、碳中和技术等战略方向。<br />
          在功能上，集成了科技成果发布、展示推广、交易撮合及产业化运营等，打通“产学研用”全链条。通过线上线下一体化服务，促进技术供需精准对接，加速创新成果转化落地，助力能源行业绿色低碳转型。依托华能产业优势，构建开放共享的创新生态，为科研机构、企业及投资者提供高效合作通道，推动能源科技高质量发展。<br /><br />
          <a target="_blank" href="https://deal.ec.chng.com.cn:5080/knowledge/kjcgk">华能集团科技创新成果运营平台（点击查看）</a>
        </div>

        <img src="../assets/banner-hn.png" class="capital_img" alt="" />
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../components/MyHead.vue";
import MyFooter from "../components/MyFooter.vue";
import { getRequest } from "../api/api";
export default {
  components: { MyHead, MyFooter },
  data() {
    return {
      //分页数据
      nespage: {
        page: 1,
        size: 10,
      },
      total: 0, //开发总条数
      newslist: [], //开发列表数据
      ssInput: '',
      active: 1,
    };
  },
  computed: {
    listCards() {
      return this.newslist.map((item) => ({
        ...item,
        summary: this.parseContentSummary(item.content),
      }));
    },
  },
  watch: {
    nespage: {
      handler() {
        this.newsList();
      },
      deep: true,
    },
  },
  methods: {
    handleSelect(sel) {
      if (this.active === sel) return;
      this.active = sel;
      this.ssInput = "";
      if (sel === 2) return;
      if (this.nespage.page !== 1) {
        this.nespage.page = 1;
      } else {
        this.newsList();
      }
    },
    // 搜索
    souSuo() {
      this.nespage.page = 1
      this.newsList()
    },
    // 开发列表接口
    newsList() {
      if (this.active === 2) return;
      let data = {
        page: this.nespage.page - 1,
        size: this.nespage.size,
        category: this.active === 3 ? 1 : 0,
        search: this.ssInput,
      };
      getRequest({ url: "/api/v1/markRelease/newsInterPage", data }).then((res) => {
        if (res.errcode == 200) {
          this.newslist = res.data;
          this.total = res.totalCount;
        }
      });
    },
    // 跳转开发详情
    toNewsD(id) {
      this.$router.push("/interconnection/details?id=" + id);
    },
    parseContentSummary(html) {
      const empty = { fields: [], intro: "" };
      if (!html || typeof window === "undefined" || !window.DOMParser) {
        return empty;
      }
      const doc = new DOMParser().parseFromString(
        `<div id="list-root">${html}</div>`,
        "text/html"
      );
      const root = doc.getElementById("list-root");
      if (!root) return empty;

      const aliasMap = {
        挂牌开始时间: "挂牌开始",
        "挂牌开始时间（年月日）": "挂牌开始",
        挂牌起始日: "挂牌开始",
        挂牌截止时间: "挂牌截止",
        "挂牌截止时间（年月日）": "挂牌截止",
        挂牌截止日: "挂牌截止",
        "挂牌金额（万元）不填写为面议": "挂牌金额",
        "挂牌金额（元）": "挂牌金额",
        出让方单位名称: "出让方",
        转让方: "出让方",
        技术领域: "项目领域",
        标的类型: "知识产权类型",
      };
      const order = [
        "项目编号",
        "业务类型",
        "项目类型",
        "知识产权类型",
        "项目领域",
        "交易方式",
        "挂牌金额",
        "出让方",
        "挂牌开始",
        "挂牌截止",
      ];
      const collected = {};
      const addField = (label, value) => {
        let key = (label || "").replace(/[:：\s]+$/g, "").trim();
        const val = (value || "").replace(/\s+/g, " ").trim();
        if (!key || !val) return;
        if (aliasMap[key]) key = aliasMap[key];
        if (!order.includes(key) || collected[key]) return;
        collected[key] = val;
      };

      root.querySelectorAll(".meta-item, .info-row").forEach((el) => {
        const labelEl = el.querySelector(".label");
        const valueEl = el.querySelector(".value");
        addField(
          labelEl ? labelEl.textContent : "",
          valueEl ? valueEl.textContent : ""
        );
      });

      root.querySelectorAll("p").forEach((p) => {
        if (p.closest("table")) return;
        const htmlInner = p.innerHTML || "";
        const re = /<strong\b[^>]*>([\s\S]*?)<\/strong>/gi;
        const strongs = [];
        let match;
        while ((match = re.exec(htmlInner))) {
          strongs.push({
            raw: match[1],
            end: match.index + match[0].length,
            index: match.index,
          });
        }
        strongs.forEach((item, i) => {
          const label = item.raw.replace(/<[^>]+>/g, "");
          const valueStart = item.end;
          const valueEnd =
            i + 1 < strongs.length ? strongs[i + 1].index : htmlInner.length;
          const value = htmlInner
            .slice(valueStart, valueEnd)
            .replace(/<[^>]+>/g, "")
            .replace(/&nbsp;/g, " ");
          addField(label, value);
        });
      });

      let intro = "";
      const introEl = root.querySelector(".intro-content");
      if (introEl) {
        intro = introEl.textContent || "";
      } else {
        root.querySelectorAll("table").forEach((table) => {
          const row = table.querySelector("tr");
          if (!row || row.children.length !== 2) return;
          const lab = (row.children[0].textContent || "").replace(/\s+/g, "");
          if (lab.indexOf("简介") !== -1) {
            intro = row.children[1].textContent || "";
          }
        });
      }
      intro = intro.replace(/\s+/g, " ").trim();
      if (intro.length > 160) intro = intro.slice(0, 160) + "…";

      const fields = order
        .filter((key) => collected[key])
        .slice(0, 8)
        .map((key) => ({ label: key, value: collected[key] }));
      return { fields, intro };
    },
  },
  created() {
    const tab = Number(this.$route.query.tab);
    if (tab === 2 || tab === 3) {
      this.active = tab;
    }
    this.newsList();
  },
};
</script>

<style lang="scss">
.newslist {
  width: 80%;
  padding-bottom: 48px;

  .sou_suo {
    margin-bottom: 20px;
    position: relative;

    .ss_but {
      height: 30px;
      color: #ffffff;
      background: #409EFF;
      padding: 0 12px;
      margin-left: 12px;
      border-radius: 2px;
      cursor: pointer;
    }

    img {
      height: 24px;
      position: absolute;
      left: 5px;
      top: 50%;
      margin-top: -12px;
      cursor: pointer;
    }

    input {
      border: none;
      background: #eeeeee;
      height: 30px;
      border-radius: 15px;
      outline: none;
      padding: 0 24px 0 34px;
      width: 600px;
    }


    // button {
    //   border: #cccccc solid 2px;
    //   padding: 0 12px;
    //   border-left: none;
    // }
  }

  .fen_ye {
    margin-top: 48px;
  }

  .col {
    background: #ffffff;
    border-radius: 12px;
    padding: 16px;
    border: 1px solid #e5e6eb;
    cursor: pointer;
    margin-bottom: 24px;

    .col_time {
      font-size: 12px;
      margin-bottom: 8px;
      font-weight: 400;
      color: #86909c;
      line-height: 20px;
    }

    .col_title {
      font-size: 20px;
      margin: 0 0 8px;
      font-weight: bold;
      color: #1d2129;
      line-height: 28px;
    }

    .list-fields {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 8px 24px;
      margin: 8px 0 10px;
    }

    .field {
      min-width: 0;
      font-size: 13px;
      line-height: 22px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .field .k {
      color: #86909c;
    }

    .field .k::after {
      content: "：";
    }

    .field .v {
      color: #4e5969;
    }

    .col_intro {
      font-size: 14px;
      color: #4e5969;
      line-height: 22px;
    }

    img {
      width: 14.18%;
    }
  }

  .title1 {
    font-size: 14px;
    margin-top: 30px;
    margin-bottom: 36px;
    font-weight: 400;
    color: #86909c;
    line-height: 22px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    img {
      width: 180px;
    }

    a {
      margin-right: 30px;
      margin-bottom: 12px;
      border: 2px solid #e5e6eb;
      border-radius: 10px;
      width: 300px;
      height: 90px;
      display: flex;
      align-items: center;
      padding: 0 28px;
      cursor: pointer;

      img {
        height: auto;
        width: 100%;
      }

      &.active {
        border-color: #165dff;
      }
    }
  }

  .title {
    font-size: 30px;
    margin-bottom: 4px;
    font-weight: bold;
    color: #1d2129;
    line-height: 38px;
  }

  .capital_img {
    width: 100%;
    margin-bottom: 32px;
  }
  .capital_content {
    font-size: 14px;
    margin-bottom: 32px;
    font-weight: 400;
    color: #4e5969;
    line-height: 28px;

    a {
      color: black;
      font-weight: bold;
    }
  }
  .capital_title {
    font-size: 24px;
    font-weight: bold;
    color: #1d2129;
    line-height: 32px;
    margin-bottom: 24px;

    span {
      color: #c9cdd4;
      margin-left: 10px;
    }
  }

}
</style>
